var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { titleCase } from "@shapeable/utils";
import { useAuth } from "./use-auth";
import pluralize from "pluralize";
import { gql } from "@apollo/client";
import { useSite } from "./use-site";
import { graphql } from "@shapeable/graphql";
import { useInfiniteScrollQuery } from "./use-infinite-scroll-query";
export var useEntityInfiniteScrollQuery = function (args) {
  var entityTypeName = args.entityTypeName,
    fetchPolicy = args.fetchPolicy,
    _a = args.orderBy,
    orderBy = _a === void 0 ? [] : _a,
    _b = args.queryFields,
    queryFields = _b === void 0 ? '' : _b,
    requiresAuthentication = args.requiresAuthentication,
    _c = args.itemsPerPage,
    itemsPerPage = _c === void 0 ? 50 : _c,
    _d = args.filter,
    filter = _d === void 0 ? {} : _d;
  var isAuthenticated = useAuth().isAuthenticated;
  var pluralSlug = titleCase(pluralize.plural(entityTypeName));
  var entityPluralSlug = pluralSlug;
  if (entityPluralSlug.endsWith('Expertises')) {
    entityPluralSlug = entityPluralSlug.replace('Expertises', 'Expertise');
  }
  ;
  // console.log('entityTypeName', entityPluralSlug);
  var site = useSite();
  // TODO - make this dynamically loaded (this requires gatsby theme changes to feed in definitions properly, which is a bit beyond scope rn)
  var listName = "list".concat(entityPluralSlug);
  var listQuery = graphql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ", "List($limit: Int, $skip: Int, $filter: ", "FilterInput, $orderBy: [OrderByInput]) {\n      ", "(filter: $filter, orderBy: $orderBy, limit: $limit, skip: $skip) {\n        meta {\n          total\n          count\n        }\n        results {\n          ...EntityValueFields\n          _optionLabel\n          ", "\n        }\n      }\n    }\n  "], ["\n    query ", "List($limit: Int, $skip: Int, $filter: ", "FilterInput, $orderBy: [OrderByInput]) {\n      ", "(filter: $filter, orderBy: $orderBy, limit: $limit, skip: $skip) {\n        meta {\n          total\n          count\n        }\n        results {\n          ...EntityValueFields\n          _optionLabel\n          ", "\n        }\n      }\n    }\n  "])), entityTypeName, entityTypeName, listName, queryFields ? queryFields : '');
  var headers = {
    site: site === null || site === void 0 ? void 0 : site.slug
  };
  return useInfiniteScrollQuery({
    query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), listQuery),
    skip: requiresAuthentication && !isAuthenticated,
    fetchPolicy: fetchPolicy,
    headers: headers,
    resultsKey: listName,
    variables: {
      limit: itemsPerPage,
      filter: filter,
      orderBy: orderBy,
      skip: 0
    }
  });
};
var templateObject_1, templateObject_2;